window.addEventListener("scroll", () => {
  const productInfoElement = document.getElementsByClassName("product-info")[0];
  const stickybarElement =
    document.getElementsByClassName("product-sticky-bar")[0];

  const offsetTop = productInfoElement.offsetHeight;
  const scrollTop = window.scrollY;
  if (scrollTop > offsetTop && stickybarElement.classList.contains("hidden")) {
    stickybarElement.classList.remove("hidden");
  }

  if (
    scrollTop <= offsetTop &&
    !stickybarElement.classList.contains("hidden")
  ) {
    stickybarElement.classList.add("hidden");
  }
});

const stickyPriceElement = document.getElementById("product-price-sticky-bar");
const priceElement = document.getElementById("product-price");
const quantityInput = document.querySelector('[name="quantity"]');
quantityInput.addEventListener("change", () => {
  const quantity = parseInt(quantityInput.value);
  const price = parseFloat(priceElement.textContent.replace(/[^0-9\.]/g, "")); // Remove currency symbol and parse to float
  const totalPrice = quantity * price;
  stickyPriceElement.textContent = `\$${totalPrice
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
});
